import { styled } from 'styled-components'

export const ErrorText = styled.div`
  color: red;
`
